import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { InstitutionIdentityProvider } from '@app/_models/institutionDto';
import { AccountService } from '@app/_services/account.service';
import { InstitutionService } from '@app/_services/institution.service';
import { ReactComponents } from '@app/react';
import { ReactWrapperComponent } from '@app/react/bridge';
import { TranslatePipe } from '@ngx-translate/core';
import { appConfig } from 'config/appConfig';
import { CollapseDirective } from 'ngx-bootstrap/collapse';
import { BsDropdownDirective, BsDropdownMenuDirective, BsDropdownToggleDirective } from 'ngx-bootstrap/dropdown';
import { NgAceNavbarDropdown } from '../../_ace/directives/navbar-dropdown.directive';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RouterLink,
    ReactWrapperComponent,
    CollapseDirective,
    NgAceNavbarDropdown,
    BsDropdownDirective,
    BsDropdownToggleDirective,
    BsDropdownMenuDirective,
    AsyncPipe,
    TranslatePipe,
  ],
})
export class NavbarComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly institutionService = inject(InstitutionService);

  protected readonly accountService = inject(AccountService);
  protected readonly ReactComponents = ReactComponents;

  isNavbarMenuCollapsed = true;
  headerImageUrl = appConfig.headerImageUrl;
  isLoggedInWithIDP = false;
  institutionIDPs: InstitutionIdentityProvider[] = [];

  ngOnInit(): void {
    this.accountService.currentJwt$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((decodedToken) => {
      this.isLoggedInWithIDP = !!decodedToken?.identity_provider;
    });
    this.institutionService
      .getInstitutionIdentityProviders()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((identityProviders) => {
        this.institutionIDPs = identityProviders;
      });
  }

  closeDropdown(dropdown: BsDropdownDirective, trigger: HTMLElement): void {
    if (!dropdown.isOpen) {
      return;
    }
    dropdown.hide();
    trigger.focus();
  }

  logout() {
    this.accountService.logout();
  }

  changePassword() {
    this.accountService.changePassword();
  }

  hasOtpConfigured() {
    return this.accountService.hasOtpConfigured$.asObservable();
  }

  async linkHin() {
    await this.accountService.navigateToLinkingIdp('hin', '/account/hin-linked');
  }

  configureOtp() {
    this.accountService.configureOtp();
  }

  async linkIdp(identityProvider: string) {
    await this.accountService.linkIdpAndForceLogin(identityProvider);
  }

  toggleNavbarMenu() {
    this.isNavbarMenuCollapsed = !this.isNavbarMenuCollapsed;
  }
}
